import { ChangeEvent, useEffect, useState } from "react";
import { IUser } from "../../type";
import "./index.css";

interface IProps {
  user: IUser;
  onClickRight: (n: string) => void;
  onClickLeft: () => void;
}

export function AboutEdit(props: IProps) {
  const [about, setAbout] = useState<string>(props.user.about || "");
  const [error, setError] = useState<string>("");

  useEffect(() => {
    setAbout(props.user.about || "");
  }, [props.user]);

  function handleChange(e: ChangeEvent<HTMLInputElement>) {
    setAbout(e.target.value);
    setError("");
  }
  let onclkbtn = () => {
    props.onClickRight(about);
  };
  return (
    <section className="section mainPage flex flex-column sectionUser profileEditStep">
      <input
        className="editDataProfile withPadd"
        type="text"
        id="about"
        name="about"
        value={about}
        onChange={handleChange}
        placeholder="О себе"
        onKeyUp={(e) => {
          if (e.code === "Enter") {
            onclkbtn();
          }
        }}
      />
      {error && <p className="error-message">{error}</p>}

      <div className="conteinerbtn">
        <div
          className="mainContentSurveyLesson-skipButton "
          onClick={() => {
            props.onClickLeft();
          }}
        >
          Назад
        </div>
        <div className="mainContentSurveyLesson-sendButton" onClick={onclkbtn}>
          Сохранить
        </div>
      </div>
    </section>
  );
}
